import {
  ALL_HEALTHCARE_ORGANIZATION_TYPE_OPTION,
  isAllHealthcareOrganizationTypeOption,
} from './all-healthcare-organization-types';
import {
  ALL_SCHOOLS_ORGANIZATION_TYPE_OPTION,
  isAllSchoolsOrganizationTypeOption,
} from './all-schools-organization-types';
import { OnOptionsLoad } from './types';

const BULK_ORGANIZATION_TYPE_OPTIONS = [
  ALL_SCHOOLS_ORGANIZATION_TYPE_OPTION,
  ALL_HEALTHCARE_ORGANIZATION_TYPE_OPTION,
] as const;

type OrganizationTypeOptionsResponse = Awaited<ReturnType<OnOptionsLoad>>;

const defaultMeta = {
  currentPage: 1,
  totalPages: 1,
  totalItems: BULK_ORGANIZATION_TYPE_OPTIONS.length,
  itemsPerPage: 100,
};

export const prependOrganizationTypeBulkOptions = (
  response: OrganizationTypeOptionsResponse,
  search?: string,
): OrganizationTypeOptionsResponse => {
  const trimmedSearch = search?.trim();

  if (trimmedSearch) {
    return response;
  }

  const existingData = response?.data?.payload?.data ?? [];

  const missingBulkOptions = BULK_ORGANIZATION_TYPE_OPTIONS.filter(
    (option) =>
      !existingData.some((item) => Number(item.id) === Number(option.id)),
  );

  if (missingBulkOptions.length === 0) {
    return response;
  }

  if (existingData.length === 0) {
    return {
      ...response,
      data: {
        payload: {
          data: [...BULK_ORGANIZATION_TYPE_OPTIONS],
          meta: response?.data?.payload?.meta ?? defaultMeta,
        },
      },
    };
  }

  return {
    ...response,
    data: {
      ...response.data,
      payload: {
        ...response.data.payload,
        data: [...missingBulkOptions, ...existingData],
      },
    },
  };
};

export const isSyntheticOrganizationTypeOption = (
  item: { id?: number | string } | null | undefined,
): boolean =>
  isAllSchoolsOrganizationTypeOption(item) ||
  isAllHealthcareOrganizationTypeOption(item);
